import React, { useCallback, useEffect, useRef } from 'react';
import './style.scss';
import '../aiml/style.scss';
import { Link } from 'react-router-dom'
import { images, scrollToTop, cardDataIoTPortfolio, IMAGES } from 'src/shared/utils/appConstant';
import { IOT_STRINGS, IOT_TIMELINE_DATA, IOT_FEATURES_DATA } from 'src/shared/utils/string';
import HomePageFooter from '../home/components/Footer';
import Footer from "src/components/footer";
import Cards from 'src/components/cards';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { pageRoutes } from 'src/shared/utils/pageRoutes.constant';



const IOTAutomation: React.FC = () => {
  const handleScrollToTop = useCallback(() => scrollToTop(), []);
  const timelineRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timelineItems = entry.target.querySelectorAll('.timeline-item');
            timelineItems.forEach((item) => {
              item.classList.add('animate');
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    if (timelineRef.current) {
      observer.observe(timelineRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className='page-container-iot'>
        <div className='image-container' style={{backgroundImage: `url(${IMAGES.IOT_BANNER})`}}>
          <div className="text-container">
            <h1 className='heading drop-in'>{IOT_STRINGS.HEADING}</h1>
            <p className='heading-desc display-none drop-in-2'>{IOT_STRINGS.DESCRIPTION}</p>
          </div>
          <p className='breadcrumb position-abs drop-in-2'>
            <Link className='breadcrumb-link' to={pageRoutes?.Home} onClick={handleScrollToTop}>Home </Link>
            <span className="breadcrumb-separator"> / </span>
            <p className="">
              <Link className='breadcrumb-link' to={pageRoutes?.Services}>Services</Link>
            </p>
            <span className="breadcrumb-separator"> / </span>
            <p className="fw-light">
              <Link className='breadcrumb-link' to={pageRoutes?.IOTAutomation} onClick={handleScrollToTop}>IoT Automation</Link>
            </p>
          </p>
          <div className='red-bg-box'></div>
        </div>

        <div className="about-our-service">
          <div className="left-section animate__animated animate__fadeInLeft animate__delay-1s">
            <h5>{IOT_STRINGS.ABOUT_SERVICE}</h5>
            <h2>{IOT_STRINGS.HEADING}</h2>
            <h3>{IOT_STRINGS.ABOUT_SERVICE}</h3>
            <p>{IOT_STRINGS.ABOUT_DESCRIPTION}
              <img alt="blue-box" className='blue-box' src={images.dark_blue_box} />
              <img alt="red-box" className='red-box' src={images.red_box} />
              <div className='red-box-sq'></div>
            </p>
            <img alt="ble-box" src={images.blue_box} />
          </div>
          <div className="right-section animate__animated animate__fadeInRight animate__delay-1s">
            <LazyLoadImage
              src={IMAGES.IOT_SIDE}
              alt='iot automation'
            />
          </div>
          <img src={images.blue_box} alt="blue box" />
          <img src={images.circles} className='circles-DevOps' alt="circles" />
        </div>

        <div className="lower-div">
          <div className="iot-portfolio-section">
            <h2>{IOT_STRINGS.WHAT_WE_OFFER}</h2>
            <Cards cardData={cardDataIoTPortfolio || []} />
          </div>
          
          <div className="why-choose-wingman">
            <h2>{IOT_STRINGS.NEXT_LEVEL_CAPABILITIES}</h2>
            <div className="features-grid">
              {IOT_FEATURES_DATA.map((feature, index) => {
                const imageMap = [IMAGES.PREDICTIVE_MAINTENANCE, IMAGES.SMART_LIGHTING, IMAGES.HOME_BUILDING, IMAGES.ENERGY_AUTOMATION, IMAGES.ONE_CLOUD];
                return (
                  <div key={index} className="feature-card">
                    <div className="feature-icon">
                      <LazyLoadImage
                        src={imageMap[index]}
                        alt={feature.title}
                      />
                    </div>
                    <div className="feature-content">
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                      <ul>
                        {feature.points.map((point, pointIndex) => (
                          <li key={pointIndex}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="generic-scope-section">
            <h2>{IOT_STRINGS.GENERIC_SCOPE_HEADING}</h2>
            <p className="scope-intro">{IOT_STRINGS.SCOPE_INTRO}</p>
            <div className="timeline-container" ref={timelineRef}>
              <div className="timeline-line"></div>
              
              {IOT_TIMELINE_DATA.map((item, index) => (
                <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                  <div className="timeline-number">{index + 1}</div>
                  <div className="timeline-content">
                    <h3>{item.heading}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="technical-architecture">
            <h2>{IOT_STRINGS.TECHNICAL_ARCHITECTURE_HEADING}</h2>
            <p>{IOT_STRINGS.TECHNICAL_ARCHITECTURE_DESCRIPTION}</p>
            <div className="architecture-image">
              <LazyLoadImage
                src={IMAGES.IOT_ARCHITECTURE}
                alt='Technical IoT Architecture - 5 Layer Stack'
                className='architecture-diagram'
              />
            </div>
          </div>

        </div>
        <HomePageFooter page="" />
        <Footer />
      </div>
    </>
  )
}

export default IOTAutomation